import createNewBranchButtonPress from '/create_node/create_node.js';
import {lightenButtonInteractions, darkenButtonInteractions} from '/misc_functions/button_color_changes.js';
import {makeElementLikeButton} from '/buttons_functions/likes_functions.js';
import {makeElementRepostButton} from '/buttons_functions/repost_functions.js';
import { SITE_URL, API_GATEWAY } from '/constants/API_constants.js';
import { createExploreMini } from '/explore_field_functions/explore_functions.js';
import { createTreeConnectionsForAll } from '/explore_field_functions/content_preview.js';
import {insertImageValue} from '/set_pics_functions/set_pic_functions.js';
import { createElement } from "/elements_functions/new_elements.js";
import { createPreview } from '/preview_functions/preview.js';
import { makeNewButton } from '/buttons_functions/custom_button_functions.js';
import { wrapLinkInSafeRedirect } from '/misc_functions/safe_redirect.js';
//----------------------------------------------------------------------------Importing modules end here------------------------------------------------------------------------------




const fileMethods = {
    "jpeg" : imageFileMethodInit,
    "png" : imageFileMethodInit,
    "avif" : imageFileMethodInit,
    "gif" : imageFileMethodInit,
    "tiff" : imageFileMethodInit,
    "webp" : imageFileMethodInit,
    "pdf" : pdfFileMethodInit
}

export async function createNodeElements(nodeId, nodeObject, authorInfo, likeStatus) {
    const nodeInfo = createElement('section', 'branch-info', null);

    console.log("Here is the nodeObject", nodeObject);
    

    const previewSection = createElement('section', 'content-preview', ['node-info-section']);

    const nameSection = createElement('section', 'name', ['node-info-section']);

    const dateAndButtonsSection = createElement('section', 'date-and-buttons', ['node-info-section']);

    const resourcesSection = createElement('section', 'resources', ['node-info-section']);

    const descriptionSection = createElement('section', 'description', ['node-info-section']);

    const tagsSection = createElement('section', 'tags', ['node-info-section']);

    insertPreview(previewSection, nodeObject.preview);

    insertName(nameSection, nodeObject.name);

    insertDateAndButtons(nodeId, dateAndButtonsSection, nodeObject.date);

    //insertAuthor(authorSection, nodeObject.author);

    insertResources(nodeId, resourcesSection, nodeObject.resources, likeStatus);

    insertDescription(descriptionSection, nodeObject.description);

    insertTagsAsTextLine(tagsSection, nodeObject.tags);

    nodeInfo.append(previewSection);
    nodeInfo.append(nameSection);
    nodeInfo.append(dateAndButtonsSection);
    nodeInfo.append(resourcesSection);
    nodeInfo.append(descriptionSection);
    nodeInfo.append(tagsSection);

    nodeInfo.onRender = () => {
        resourcesRender(resourcesSection, resourcesSection.buttonsGroup);
    }

    const nodeElements = [];

    nodeElements.push(nodeInfo);

    return nodeElements;


}

//-------------------------Node set-up functions-------------------------------------------------
//-------------------------Preview Functions-----------------------------------------------------
function insertPreview(previewSection, preview) {
    const previewElement = createPreview(preview);
    previewSection.append(previewElement);
}

function youtubeMethodInit(previewUrl) {
    const previewContent = document.createElement('iframe');
    previewContent.setAttribute("id", "youtube-preview-content");
            
    previewContent.src = previewUrl;

    return previewContent;
}

function soundCloudMethodInit(previewUrl) {
    const previewContent = document.createElement('iframe');
    previewContent.setAttribute("id", "soundcloud-preview-content");
            
    previewContent.src = previewUrl;

    return previewContent;
}

function imageFileMethodInit(previewPath) {

}

function pdfFileMethodInit(previewPath) {

}
//------------------------------------------------------------------------------------------------------

function insertName(nameSection, name) {
    const nameLabel = document.createElement('h2');

    nameLabel.innerText = name;

    nameSection.append(nameLabel);
}

function insertDateAndButtons(nodeId, dateAndButtonsSection, date) {
    const dateInfo = document.createElement('p');    
    console.log("here is your date " + date + " " + Date.parse(date));
    const newDate = new Date(Date.parse(date))
    const month = new Intl.DateTimeFormat("en-US", {month : 'long'}).format(newDate);
    dateInfo.innerText = month + " " + newDate.getDate() + ", " + newDate.getFullYear();
    console.log("Get month " + month);
    
    const branchItButton = document.createElement('button');
    branchItButton.innerText = 'Branch it!';
    branchItButton.setAttribute('id', 'branch-button');
    makeNewButton(branchItButton, 'light-black', 'white', null, 'lighten');

    const loggedInButtons = [];
    
    const reactionButton = document.createElement('button');
    reactionButton.innerText = "React";
    loggedInButtons.push(reactionButton);
    
    const awardButton = document.createElement('button');
    awardButton.innerText = "Award";
    loggedInButtons.push(awardButton);
    
    let repostButton = document.createElement('button');
    repostButton.innerText = "Repost";
    loggedInButtons.push(repostButton);
    
    const buttonsGroup = document.createElement('div');
    buttonsGroup.setAttribute('id', 'buttons-group');



    buttonsGroup.append(branchItButton);
    
    const loginToken = localStorage.getItem("branchof_access_token");
    if(loginToken!==null && loginToken!==undefined) {
        buttonsGroup.append(...loggedInButtons);
        for (let button of loggedInButtons) {
            makeNewButton(button, 'grey', 'black', null, 'darken');
        }
    }
    buttonsGroup.append(reactionButton);
    buttonsGroup.append(awardButton);
    repostButton = makeElementRepostButton(repostButton, nodeId);
    branchItButton.addEventListener('click', () => createNewBranchButtonPress(nodeId));
    
    dateAndButtonsSection.append(dateInfo);
    dateAndButtonsSection.append(buttonsGroup);
    

}

function insertResources(nodeId, resourceSection, resources, likeStatus) {
    if(resources===null || resources.length===0) {
        const noResourcesCaption = createElement('p', 'no-resources-caption', null);

        noResourcesCaption.innerText = 'The author provided no resources for this branch...'

        resourceSection.append(noResourcesCaption);

        return null;
    }

    for (let resourceInfo of resources) {

        const resource = createElement('div', null, ['resource-link-and-commentary']);

        const resourceLink = document.createElement('a');
        resourceLink.href=wrapLinkInSafeRedirect(resourceInfo.link);
        resourceLink.innerText=resourceInfo.link;
        resourceLink.target = '_blank';
        resourceLink.classList.add('resource-link');
        
        const resourceComment = document.createElement('p');
        resourceComment.innerText= '- ' + resourceInfo.commentary;
        resourceComment.classList.add('resource-comment');

        resource.append(resourceLink);
        resource.append(resourceComment);
        
        resourceSection.append(resource);
    }
    //----------------------------Button------------------------------
    const buttonsGroup = document.createElement('div');
    buttonsGroup.setAttribute('id', 'resources-buttons-group');
    
    const buttonLike = document.createElement('button');
    buttonLike.setAttribute('id', 'resources-like-button');
    buttonLike.innerText = 'Like';
    
    const buttonDislike = document.createElement('button');
    buttonDislike.setAttribute('id', 'resources-dislike-button');
    buttonDislike.innerText = 'Dislike';
    
    buttonsGroup.append(buttonLike);
    buttonsGroup.append(buttonDislike);

    resourceSection.buttonsGroup = buttonsGroup;
    
    resourceSection.append(buttonsGroup);

    if (likeStatus==null) {
        makeElementLikeButton(nodeId, buttonLike, 'post-like');
        makeElementLikeButton(nodeId, buttonDislike, 'post-dislike');
    } else if(likeStatus===true) {
        makeElementLikeButton(nodeId, buttonLike, 'delete-like');
        makeElementLikeButton(nodeId, buttonDislike, 'post-dislike');
    } else {
        makeElementLikeButton(nodeId, buttonLike, 'post-like');
        makeElementLikeButton(nodeId, buttonDislike, 'delete-dislike');
    }
    
}

function resourcesRender(resourceSection, buttonsGroup) {
    const allResourceLinks = resourceSection.querySelectorAll('.resource-link-and-commentary');
    if(allResourceLinks.length>0) {
        const lastLinkElement = allResourceLinks[allResourceLinks.length - 1];
        console.log("resourceSection ", resourceSection);
        console.log("lastLinkElement ", lastLinkElement);
        console.log("buttonsGroup ", buttonsGroup);

        const csContainer = getComputedStyle(resourceSection);
        const csLast = getComputedStyle(lastLinkElement);
        const buttonsGroupStyle = getComputedStyle(buttonsGroup);

        // parent padding (rendered)
        const paddingLeft  = parseFloat(csContainer.paddingLeft);
        const paddingRight = parseFloat(csContainer.paddingRight);
        const paddingBottom = parseFloat(csContainer.paddingBottom);

        // last link margins (rendered)
        const marginLeft  = parseFloat(csLast.marginLeft);
        const marginRight = parseFloat(csLast.marginRight);

        // widths
        const parentWidth = resourceSection.clientWidth;   // inside padding
        const lastWidth   = [...lastLinkElement.children].map(child => child.offsetWidth).reduce((sum, width) => sum + width, 0)
        const actionsWidth = buttonsGroup.offsetWidth;
        const buttonsGroupHeight = buttonsGroup.offsetHeight;
        const additionalWidthControl = 15; //px

        // total line width if placed inline
        const totalWidth =
            paddingLeft +
            marginLeft +
            lastWidth +
            //marginRight +
            //paddingRight +
            additionalWidthControl +
            actionsWidth;

        console.log("totalWidth ", totalWidth);
        console.log("parentWidth ", parentWidth);
        console.log("buttonsGroupHeight ", buttonsGroupHeight);
        
        // decide
        if (totalWidth > parentWidth) {
            resourceSection.style.paddingBottom = paddingBottom + buttonsGroupHeight + "px";
        }
    }

}

function insertDescription(descriptionPreview, description) {
    const descriptionText = document.createElement('p');

    if(description!=null && description.length>0) {
        descriptionText.innerText = description;
    } else {
        descriptionText.innerText = 'the author supplied no description';
    }

    descriptionPreview.append(descriptionText);
}

function insertTagsAsTextLine(tagsSection, tags) {

    const tagsLine = document.createElement('p');

    if(tags==null || tags.length===0) {
        tagsLine.innerText = 'no tags';

        return null;
    }

    tagsLine.setAttribute("id", "tags-line");

    if (tags[tags.length-1]===',')
        tags=tags.substring(0, tags.length-1)
    
    tagsLine.innerText = "Tags: ";

    for (let i in tags) {
        const tag = document.createElement('a');
        tag.innerText=tags[i];
        tag.href=SITE_URL+'/search/branches='+tags[i]+'/page=1';
        tagsLine.append(tag);

        if (i!=(tags.length-1)) {
            tagsLine.append(', ');
        }
    }

    tagsSection.append(tagsLine);

}

function insertTagsWithHeaderAndBoxes(tagsSection, tags) {

    const tagsCollector = document.createElement('div');
    tagsCollector.setAttribute("id", "tags-collector");

    const tagsLabel = document.createElement('h3');
    tagsLabel.innerText = "Tags"

    if (tags[tags.length-1]===',')
        tags=tags.substring(0, tags.length-1)

    const tagsArray = tags.split(',');

    for (let tagInfo of tagsArray) {
        const tag = document.createElement('div');
        const tagLabel = document.createElement('p');

        tagLabel.innerText = tagInfo;

        tag.append(tagLabel);

        tag.classList.add("tag");

        tagsCollector.append(tag);
    }

    tagsSection.append(tagsLabel);
    tagsSection.append(tagsCollector);

    
}


//-------------------------Right side bar info functions-------------------------------------------------
export function putInfoIntoRightSideBar(author) {
    const rightSideBar = document.getElementById('right-side-bar');
    if (author!==null && author!==undefined) {
        const authorType = author.type;
        if(authorType===null || authorType===undefined)
            return ;
        else if(authorType==="REGULAR_USER")
            rightSideBar.append(createAuthorInfo(author));
        else if(authorType==="ANONYMOUS") {
            const authorInfo = {
                username : null,
                accountName : "Anonymous author",
                accountBio : "This branch was submitted anonymously. No one has claimed authorship over it yet.",
                profilePic: null
            }
            rightSideBar.append(createAuthorInfo(authorInfo));
        }
    }

}

function createAuthorInfo(author) {
    const authorInfo = document.createElement('div');
    authorInfo.setAttribute("id", "author-info");

    const regularName = document.createElement('a');
    regularName.setAttribute("id", "author-regular-name");
    regularName.innerText = author.accountName;
    regularName.href = SITE_URL + '/user/page/' + author.username;
    
    const username = document.createElement('a');
    username.setAttribute("id", "author-username");
    username.innerText = '@'+author.username;
    username.href = SITE_URL + '/user/page/' + author.username;

    const authorNameAndUsername = createElement('div', 'author-name-and-username', null);

    if(author.accountName!==null) {
        authorNameAndUsername.append(regularName);
    }

    if(author.username!==null && author.username!==undefined)
        authorNameAndUsername.append(username);
    

    const profilePic = document.createElement('img');
    profilePic.setAttribute("id", "author-profile-pic");
    //profilePic.src = author.profilePic;
    if(author.profilePic!==null && author.profilePic.picPath!==null && author.userStatus!=='suspended' && author.userStatus!=='banned') {
        insertImageValue(profilePic, author.profilePic.picPath);
    } else {
        profilePic.src = SITE_URL + '/images/icons/profile_account.png';
    }

    if(author.userStatus==='suspended' || author.userStatus==='banned') {
        profilePic.src = '/images/icons/profile_account.png';
        
        username.innerText = 'This user has been restricted';

        regularName.remove();
    }

    const profilePicAndNames = createElement('div', 'author-profile-pic-and-names', null);

    const profileBio = document.createElement('p');
    profileBio.setAttribute("id", "author-bio");
    profileBio.innerText = author.accountBio;

    const subscribeButton = document.createElement('button');
    subscribeButton.setAttribute("id", "author-subscribe-button");
    subscribeButton.innerText = "Subscribe";

    profilePicAndNames.append(profilePic, authorNameAndUsername);
    
    authorInfo.append(profilePicAndNames);
    authorInfo.append(profileBio);
    //authorInfo.append(subscribeButton);

    return authorInfo;
}